import { render, staticRenderFns } from "./ReportsUserPkh.vue?vue&type=template&id=a5451302&"
import script from "./ReportsUserPkh.vue?vue&type=script&lang=js&"
export * from "./ReportsUserPkh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports